<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-m_cost"></i>成本信息浏览</div>

    <div class="page-content">
      <el-form style="font: bold" :inline="true" label-width="120px" size="small" :model="formInline">
        <el-form-item label="指定月份成本：">
          <el-date-picker v-model="belongMonthly" format="yyyy-MM" value-format="yyyy-MM" style="width: 90%" type="month"> </el-date-picker>
        </el-form-item>
        <el-form-item label="店铺名称：">
          <el-select v-model="formInline.shopId" clearable filterable placeholder="请选择" @change="realChange">
            <el-option v-for="types in dataShops" :key="types.id" :value="types.id" v-text="types.shopName" :label="types.shopName" />
          </el-select>
        </el-form-item>
        <el-form-item label="站点：">
          <el-select v-model="formInline.site" style="width: 100%" clearable placeholder="请选择">
            <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100vh - 1.5rem)"
        :data="tableData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        style="
            width: 96%;
            margin-top: 10px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="sku" label="SKU" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="attribute" label="属性" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="site" label="站点" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="issueCount" label="出单" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="returnsCount" label="退货" width="220" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="costUnitPrice" label="成本单价" width="100" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="singleTotalPrice" label="单品总成本" show-overflow-tooltip width="220"> </el-table-column>
        <el-table-column prop="hytc" label="头程单价" width="100" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="tcdpzcb" label="单品总头程" width="100" show-overflow-tooltip> </el-table-column>
      </el-table>
      <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    belongMonthly(val) {
      if (val == null) {
        this.belongMonthly = getPreMonth();
      }
    },
  },
  data() {
    var user = window.sessionStorage["user"];
    return {
      dataShops: [],
      /*创建角色*/
      addRoleDialog: false,
      addrole: {
        id: undefined,
        sku: "",
        attribute: "",
        numberPackages: "",
        fnsku: "",
        type: 11002001,
        site: "",
        shopName: "",
        packagesHigh: "",
        cost: "",
        packagesLong: "",
        packagesWeight: "",
        packagesWide: "",
      },
      modelTitle: "",
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: "",
        description: "",
        authorityIds: [],
      },
      rules1: {
        sku: [{ required: true, message: "sku是必填的", trigger: "blur" }],
        numberPackages: [{ required: true, message: "装箱数是必填的", trigger: "blur" }],
        attribute: [{ required: true, message: "属性是必填的", trigger: "blur" }],
        fnsku: [{ required: true, message: "fnsku是必填的", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        belongMonthly: "",
        shopId: "",
        shopName: "",
        site: "",
      },
      belongMonthly: this.getPreMonth(),
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      Fnupload: {
        id: "",
        businessType: "",
      },
      uploadDialog: false,
      dialogVisible: false,
      fileFnList: [],
      businessType: 0,
      formFilename: "上传文件",
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      dataSites: [],
      flagClick: false,
      // 双击修改
      attribute: false,
      cost: false,
      failReason: false,
      fnsku: false,
      numberPackages: false,
      packagesHigh: false,
      packagesLong: false,
      packagesWeight: false,
      packagesWide: false,
      shopName: false,
      site: false,
      sku: false,
      type: false,
    };
  },
  created() {
    this.getAllDicts();
  },
  methods: {
    getAllDicts() {
      /*获取所有店铺*/
      this.axios.get("/api/shop/list").then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
          this.getAllSites();
        }
      });
    },
    getAllSites() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key) {
            if (key.indexOf("1130") == 0) {
              // 站点
              let siteData = data[key];
              siteData.map((item) => {
                item.codeName = item.codeValue + "（" + item.codeName + "）";
              });

              this.dataSites = siteData;
              this.query(); /*绑定树*/
            }
          }
        }
      });
    },
    realChange(val) {
      var obj = {};
      obj = this.dataShops.find(function(i) {
        return i.id === val;
      });
      this.formInline.shopName = obj.shopName;
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      this.$data.tableData = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.$data.total = resp.data.data.total;
    },
    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },
    query() {
      //条件筛选
      this.formInline.belongMonthly = this.belongMonthly;
      let o = {
        ...this.formInline,
      };
      if (this.formInline.belongMonthly != null && this.formInline.belongMonthly != "" && this.formInline.belongMonthly != undefined) {
        o.belongMonthly = moment(this.formInline.belongMonthly).format("YYYY-MM");
      } else {
        delete o.belongMonthly;
      }
      this.axios
        .get("/api/shop-sku-cost/list", {
          // , sku: this.$data.formInline.sku, type: this.$data.formInline.type
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },
    getPreMonth() {
      var cur = new Date();
      return cur.getFullYear() + "-" + this.checkMonth(cur.getMonth());
    },
    checkMonth(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #e4653a;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form {
      width: 100%;
      height: 36px;
      line-height: 36px;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #e4653a;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}
</style>
